var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.25H16.5V15.75H1.5V2.25H9V5.25ZM3 14.25H4.5V12.75H3V14.25ZM4.5 11.25H3V9.75H4.5V11.25ZM3 8.25H4.5V6.75H3V8.25ZM4.5 5.25H3V3.75H4.5V5.25ZM6 14.25H7.5V12.75H6V14.25ZM7.5 11.25H6V9.75H7.5V11.25ZM6 8.25H7.5V6.75H6V8.25ZM7.5 5.25H6V3.75H7.5V5.25ZM15 14.25V6.75H9V8.25H10.5V9.75H9V11.25H10.5V12.75H9V14.25H15ZM13.5 8.25H12V9.75H13.5V8.25ZM12 11.25H13.5V12.75H12V11.25Z",
    fill: "#6384E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.81316cd695d5411116923a46f1d67175.svg";
export { ForwardRef as ReactComponent };